<div class="context">
    <div class="context-media" *ngIf="icon">
        <ng-content class="context-media-object" select="fui-icon"></ng-content>
    </div>
    <div class="context-label">
        <div class="context-label-title" id="modal-window-toolbar-label">
            {{title | translate: titleParams}}
        </div>
    </div>
</div>
<button class="action" (click)="close()">
    <div class="action-media">
        <fui-icon [height]="12" [icon]="'close'" [width]="12"></fui-icon>
    </div>
</button>
